import type ButtonVariants from '@heathmont/moon-core-tw/lib/button/private/types/ButtonVariants';
import Translate from '~/client/shared/i18n/Translate';
import useCookie from '~/shared/hooks/useCookie';
import Button from '../Button';

type Props = {
  variant: ButtonVariants;
  id: string;
};

const BlockedCountryButton: FC<Props> = ({ variant, id }) => {
  const { handleClick } = useBlockedCountryButton();

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      fullWidth
      className="font-normal"
    >
      <Translate id={id} />
    </Button>
  );
};

const useBlockedCountryButton = () => {
  const [, setDismissBlockedCountry] = useCookie(
    'blocked-jurisdiction-dismissed',
  );
  const handleClick = () => setDismissBlockedCountry(undefined);
  return { handleClick };
};

export default BlockedCountryButton;
